export default __webpack_public_path__ + "media/images/favicon-6699b2f63c8f854775c88b15eab4011c.png";